import zod from "zod";
import { z } from "/@/modules/zodUtils";

export const invest24WorkTypes = ["通勤", "拠点宿泊", "その他"] as const;
export const Invest24WorkTypeScheme = z.enum(invest24WorkTypes);
export type Invest24WorkType = zod.infer<typeof Invest24WorkTypeScheme>;
